/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ScheduleCallOff = {
    properties: {
        ScheduleId: {
    type: 'number',
    isRequired: true,
    format: 'int64',
},
        companyId: {
    type: 'number',
    isRequired: true,
    format: 'int64',
},
        departmentId: {
    type: 'number',
    isRequired: true,
    format: 'int64',
},
        facilityId: {
    type: 'number',
    isRequired: true,
    format: 'int64',
},
        eventMetricId: {
    type: 'number',
    isRequired: true,
    format: 'int64',
},
        assignee: {
    type: 'number',
    isRequired: true,
    format: 'int64',
},
        postedBy: {
    type: 'number',
    isNullable: true,
    format: 'int64',
},
        postedByEmployeeDepartmentId: {
    type: 'number',
    isNullable: true,
    format: 'int64',
},
        note: {
    type: 'string',
    isNullable: true,
},
        eventTime: {
    type: 'string',
    isRequired: true,
    format: 'date-time',
},
        date: {
    type: 'string',
    isRequired: true,
    format: 'date',
},
        startTime: {
    type: 'string',
    isRequired: true,
},
        endTime: {
    type: 'string',
    isRequired: true,
},
    },
};